export default __webpack_public_path__ + "static/media/dialogue-africa-ghana-twi-logo.0d4e3d15.png";